<template>
    <transition name="fadeIn" appear>
        <section class="hero">
            <div :class="['imageContainer', { overflowHidden: sensitiveOverlay }]">
                <Badge
                    v-if="currentArtwork.flag.featured"
                    type="featured"
                    icon="magic_button"
                    :label="siteContent.featured"/>
                <div :class="['imageWrapper', { sensitive: sensitiveOverlay }, { notSensitive: !sensitiveOverlay }]">
                    <img class="image" loading="lazy"
                        v-for="(image, index) in currentArtwork.media.carousel"
                        :key="index"
                        :src="image.url"
                        :alt="currentArtwork.content.title.en"/>
                </div>
            </div>

            <SensitiveOverlay
                v-if="sensitiveOverlay"
                @displayMedia="showSensitive=true"/>

            <BlurredBackground
                :image="currentArtwork.media.carousel[0].url"/>
        </section>
    </transition>
</template>

<script>
    import SensitiveOverlay from '@/components/entry/SensitiveOverlay'

    export default {
        name: 'Carousel',
        components: {
            SensitiveOverlay
        },
        props: {
            currentArtwork: Object
        },
        data() {
            return {
                showSensitive: false
            }
        },
        computed: {
            sensitiveOverlay() {
                if(this.showSensitive) {
                    return false
                } else if(this.currentArtwork.flag.sensitive && !this.preferences.showSensitive) {
                    return true
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    @import '../../scss/variables';

    .fadeIn-enter-active {
        transition: all 1s ease-in-out;
    }

    .fadeIn-enter, .fadeIn-leave {
        opacity: 0;
    }

    .fadeIn-enter-to {
        opacity: 1;
    }

    .fadeIn-leave-to {
        opacity: 0;
    }

    .hero {
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        padding: 1.5rem 1rem 0 1rem;
    }

    .imageContainer {
        display: flex;
        position: relative;
        overflow-x: auto;
        overflow-y: hidden;
        border-radius: 1rem;
        padding-bottom: 1rem;
        height: 100%;
        scroll-snap-type: x mandatory;

        &::-webkit-scrollbar {
            height: 0.5rem;
        }

        &::-webkit-scrollbar-track {
            background: var(--color-white-40);
            border-radius: 0.5rem;
            margin: 0 1rem;
        }

        &::-webkit-scrollbar-thumb {
            background: var(--color-primary-500);
            border-radius: 1rem;
        }

        &::-webkit-scrollbar-thumb:hover {
            background: var(--color-primary-300);
        }
    }

    .image {
        max-width: 100%;
        max-height: 75vh;
        height: auto;
        scroll-snap-align: start;
        margin-right: 0.5rem;
        border-radius: 1rem;

        &:last-of-type {
            margin: 0;
        }
    }

    .imageWrapper {
        display: flex;
        width: 100%;
        transition: $transition-eio-60;
    }

    .sensitive {
        filter: blur(4rem) brightness(0.8);
    }

    .notSensitive {
        filter: blur(0) brightness(1);
    }

    .overflowHidden {
        overflow: hidden;
    }

    @media all and (max-width: 560px) {
        .hero {
            padding: 0;
        }

        .imageContainer {
            border-radius: 0;
        }

        .image {
            border-radius: 0 0 1rem 1rem;
            margin-right: 0.25rem;
        }
    }
</style>